// bao migrate skip
import * as ko from "knockout";
import Bao from "../../../services/bao-service";
import SubscriptionViewModel from "../../../factories/subscription-view-model";
import TabController from "../../../factories/tab-controller";
import TabPage from "../../../factories/tab-page";

class RoleShiftbookTabDialog extends SubscriptionViewModel {
    ShiftbookId: KnockoutObservable<string>;
    ShiftbookTypeName: KnockoutObservable<string>;
    Parent: {
        RoleName: KnockoutObservable<string>;
        TabPage: Factories.TabPage;
        SessionTabId: string;
    } = null;
    RoleId: KnockoutObservable<string>;
    RoleName: KnockoutObservable<string>;
    ShiftbookName: KnockoutObservable<string>;
    IsNew: KnockoutObservable<boolean>;
    IsShiftbookContext: KnockoutObservable<boolean> = ko.observable(false);
    RoleShiftbookId: KnockoutObservable<string>;

    TabViewModel = new TabController(false);
    TabModels = ko.observableArray([]);
    SelectedTabId = ko.observable('');

    constructor($data: {
        ShiftbookName,
        Parent: any,
        fromShiftbook: boolean,
        TabModel: []
    }, $dialog) {
        super($data.Parent.TagPage);
        $.extend(this, $data);
        this.IsShiftbookContext($data.fromShiftbook);
        if (this.IsNew() && !ko.unwrap(this.IsShiftbookContext)) {
            this.RoleName(ko.unwrap($data.Parent.RoleName));
        }

        this.ShiftbookId.subscribe((newval) => {
            this.Parent.TabPage.IsLoading(true);
            this.TabViewModel.DestroyAll();

            Bao.post("UadmFinitoCustom/RoleShiftbookTab/GetNewModelForShiftbook", JSON.stringify({
                roleId: ko.unwrap(this.RoleId),
                shiftbookId: newval
            }))
                .then((value) => {
                    ko.map.fromJS(value.Model, this);
                    this.TabModels(ko.unwrap(value.TabModels));
                })
                .always(() => {
                    this.Parent.TabPage.IsLoading(false);
                });
        });

        this.TabModels.subscribe((newValue) => {
            this.TabViewModel.Tabs([]);
            if (newValue) {
                $.each(ko.toJS(newValue), (index, item) => {
                    var newTab = new TabPage(null, item.Title);
                    newTab.Url(item.Url);
                    newTab.IsClosable(false);
                    newTab.PreLoad(item.PreLoad);
                    newTab.Visible(item.Visible);
                    newTab.ObjectId(item.TabId);
                    newTab.AutoSelect = index === 0;
                    this.TabViewModel.AddTab(newTab);
                });
            }
            const tabs = this.TabViewModel.Tabs();
            if (tabs.length !== 0 && this.SelectedTabId().length !== 0) {
                var selectTab = tabs.filter(x => x.ObjectId() == this.SelectedTabId());
                if (selectTab.length !== 0) {
                    this.TabViewModel.SelectTab(selectTab[0]);
                }
            }
            this.SelectedTabId('');
        });


        this.TabModels(ko.unwrap($data.TabModel));
    }
    /*
     * Returns model from dialog and tabs to save
     * */
    GetModelToSave() {
        const roleShiftbookTabModel = [];
        let generalTabModel: any = null;

        const tabs = this.TabViewModel.Tabs();

        // sets model for additional tabs
        tabs.forEach((tab) => {
            const viewModel = tab.ViewModel();
            const shiftbookTabId = viewModel.TabPage.ObjectId();
            delete viewModel.RoleShiftbookTabDialog;
            delete viewModel.TabPage;
            viewModel.RoleShiftbookId = this.RoleShiftbookId();

            if (shiftbookTabId === '60fd2dfd-4265-4f7b-8214-90d41b8b81ab') { // the hard-coded identifier of the general tab. Does not exist in the database
                generalTabModel = ko.map.toJS(viewModel);
            }
            else {
                roleShiftbookTabModel.push(ko.map.toJS(viewModel));
            }
        });
        // sets main model of dialog
        const viewModel = this;
        delete viewModel.Parent;
        delete viewModel.TabViewModel;
        delete viewModel.TabPage;

        return { mainDialogModel: ko.map.toJS(viewModel), generalTabModel: ko.map.toJS(generalTabModel), roleShiftbookTabModel: roleShiftbookTabModel };
    }
}
export default RoleShiftbookTabDialog;